"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationStatePath = '/locationState';
exports.userStatePath = '/userState';
exports.allowedPatchPaths = [exports.locationStatePath, exports.userStatePath];
//# sourceMappingURL=notification.js.map